"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Locations = void 0;
const react_1 = __importDefault(require("react"));
const ProviderTabs_styles_1 = require("../../ProviderTabs.styles");
const ProviderLocations_1 = require("../../../ProviderLocations");
const Locations = (props) => {
    return (react_1.default.createElement(ProviderTabs_styles_1.Content, { "data-testid": "locations" },
        react_1.default.createElement(ProviderLocations_1.ProviderLocations, Object.assign({}, props))));
};
exports.Locations = Locations;
exports.default = exports.Locations;
//# sourceMappingURL=Locations.js.map